/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("web/script/polyfills/fetch");
var classListPolyfill = require("web/script/polyfills/classList");

import analytics from "web/script/analytics/analytics";
import cookie from "./cookie";

var FontFaceObserver = require("fontfaceobserver");
var docClasses = document.documentElement.classList;

function fontLoadComplete() {
    cookie("withfonts", "1", { path: "/" });
    docClasses.add("fonts-loaded");
}

function observeFont(name) {
    return new FontFaceObserver(name).load(null, 5000).catch(function() {
        console.error("Custom font", name, "did not load within 5 seconds.");
        analytics.event("fonts", "failed", name, true);
    });
}

function fontList() {
    return ["Brown", "Brown Bold", "IBM Plex Sans Light"];
}

export default function() {
    if (docClasses.contains("fonts-loaded")) {
        return;
    }

    // Note that if these font names become out of sync with the font
    // names declared in the css. The fonts-loaded will only be
    // triggered after the explict timeout (or default if not
    // specified) passed to the fontfaceobserver load method.
    Promise.all(fontList().map(observeFont)).then(fontLoadComplete);
}

